/**
 * Feedback component
 *
 * Description:
 * Displays feedback and evaluation results for a quiz or lesson, including score, feedback text, and retry option.
 *
 * Features:
 * - Shows user's review and score.
 * - Displays feedback text based on score ranges.
 * - Provides a button to retry the video/quiz.
 * - Uses Material-UI for UI elements.
 */
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';

import classes from './Feedback.module.css';

const Feedback = props => {
  const { t } = useTranslation(['lesson']);
  return (
    <>
      {/* Custom prop: 'className' for feedback container styling */}
      <div className={classes.feedbackContainer}>
        <aside className={classes.leftSection}>
          {props.calificationData.autoEvaluate ? (
            <>
              <p className={classes.text}>{t('your_review')}</p>
              <p className={classes.text}>
                {t('qualification')}:{' '}
                <span className={classes.score}>
                  {props.evaluate.score}
                </span>
              </p>
              {props.evaluate.score < 70 && (
                <p className={classes.feedbackText}>
                  {t('not_approving')}
                </p>
              )}
              {/* <p>{date}</p> */}
            </>
          ) : (
            <p className={classes.text}>{t('your_review')}</p>
          )}
        </aside>
        <aside className={classes.rightSection}>
          {props.calificationData.autoEvaluate && (
            <>
              <p className={classes.text}>Retroalimentación</p>
              <p className={classes.feedbackText}>
                {props.evaluate.score <=
                props.feedbackData.response.firstRange ? (
                  <span>
                    {props.feedbackData.response.firstRangeFeed}
                  </span>
                ) : props.evaluate.score <=
                  props.feedbackData.response.secondRange ? (
                  <span>
                    {props.feedbackData.response.secondRangeFeed}
                  </span>
                ) : props.evaluate.score <=
                  props.feedbackData.response.thirdRange ? (
                  <span>
                    {props.feedbackData.response.thirdRangeFeed}
                  </span>
                ) : (
                  ''
                )}
              </p>
            </>
          )}
        </aside>
      </div>
      {/* Custom prop: 'className' for button container styling */}
      <aside className={classes.btnsContainer}>
        <Button
          // Custom prop: 'onClick' passes returnVideo handler
          onClick={props.returnVideo}
          className={classes.nextBtn}
        >
          {t('try_again')} <ReplayIcon />
        </Button>
      </aside>
    </>
  );
};

Feedback.propTypes = {
  /**
   * Feedback data object containing response ranges and feedback text
   */
  feedbackData: PropTypes.object,
  /**
   * Calification data object containing evaluation flags
   */
  calificationData: PropTypes.object,
  /**
   * Evaluation object containing score
   */
  evaluate: PropTypes.object,
  /**
   * Object to handle view changes (not used directly here)
   */
  changeView: PropTypes.object,
  /**
   * Function to handle returning to the video/quiz
   */
  returnVideo: PropTypes.func
};

Feedback.defaultProps = {
  feedbackData: {},
  calificationData: {},
  evaluate: {},
  changeView: {},
  returnVideo: undefined
};

export default Feedback;
